import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Table from 'react-bootstrap/Table';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import { CommonAdminEditIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import s from './StaticPageManagement.css';

export class StaticPageManagement extends Component {

	render() {
		const { formatMessage } = this.props.intl;
		let data = [{
			id: 1,
			pageName: formatMessage(messages.Support),
			pageUrl: '/support'
		}, {
			id: 2,
			pageName: formatMessage(messages.user),
			pageUrl: '/user'
		}, {
			id: 3,
			pageName: formatMessage(messages.partner),
			pageUrl: '/partner'
		}, {
			id: 4,
			pageName: formatMessage(messages.partnerPrivacyPolicy),
			pageUrl: '/partner/privacy-policy'
		}, {
			id: 5,
			pageName: formatMessage(messages.legal),
			pageUrl: '/legal'
		},
		{
			id: 6,
			pageName: formatMessage(messages.termsOfService),
			pageUrl: '/terms-of-service'
		}];

		return (
			<div>
				<div className='tableOuterContainer'>
					<Table className="tableContainer">
						<thead>
							<tr>
								<th scope="col"><FormattedMessage {...messages.id} /></th>
								<th scope="col"><FormattedMessage {...messages.pageName} /></th>
								<th scope="col"><FormattedMessage {...messages.preview} /></th>
								<th scope="col"><FormattedMessage {...messages.editAction} /></th>
							</tr>
						</thead>
						<tbody>
							{
								data?.map((o) => {
									return (
										<tr>
											<td data-label={formatMessage(messages.id)}>{o?.id}</td>
											<td data-label={formatMessage(messages.pageName)}>{o?.pageName}</td>
											<td data-label={formatMessage(messages.preview)}>
												<div>
													<a href={o?.pageUrl} target={'_blank'} className='actionLinkText'><FormattedMessage {...messages.preview} /></a>
												</div>
											</td>
											<td data-label={formatMessage(messages.editAction)}>
												<div>
													<Link to={'/siteadmin/staticpage/edit/' + o?.id} className={s.noLink}>
														<CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
														<span className={s.vtrMiddle}>
															<FormattedMessage {...messages.editAction} />
														</span>
													</Link>
												</div>
											</td>
										</tr>
									);
								})
							}
						</tbody>
					</Table>
				</div>
			</div >
		)
	}
}

export default injectIntl(withStyles(s)(StaticPageManagement));